import { apolloClient } from '~/apollo-client';
import { BillingDataSource, FunnelBillingExperience } from '~/typings/context';
import { FunnelName } from '~/typings/graphql';
import { FETCH_FUNNEL_BILLING_EXPERIENCE } from './fetch-funnel-billing-experience.queries';

export const fetchFunnelBillingExperience = async (
  params: FetchFunnelBillingExperienceParams,
): Promise<FetchFunnelBillingExperienceResponse> => {
  const { data } = await apolloClient.query<any, any>({
    query: FETCH_FUNNEL_BILLING_EXPERIENCE,
    variables: {
      input: {
        utilityId: params.utilityId,
        billing: params.billing,
        funnel: params.funnel ?? FunnelName.CommunitySolar,
        userId: params.userId,
      },
    },
    fetchPolicy: 'no-cache',
  });

  if (!data.funnelBillingExperienceConfiguration) {
    throw new Error('Funnel billing experience configuration not found');
  }

  return {
    funnelBillingExperience: data.funnelBillingExperienceConfiguration.funnelBillingExperience,
  };
};

export interface FetchFunnelBillingExperienceParams {
  utilityId: number;
  billing?: BillingDataSource;
  funnel?: string;
  userId?: number;
}

export interface FetchFunnelBillingExperienceResponse {
  funnelBillingExperience: FunnelBillingExperience;
}
